/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Selectable field names, per condition field type.
 * @export
 * @interface FieldNamesMeta
 */
export interface FieldNamesMeta {
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldNamesMeta
     */
    numeric: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldNamesMeta
     */
    extraData: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldNamesMeta
     */
    siteExtraData: Array<string>;
}

/**
 * Check if a given object implements the FieldNamesMeta interface.
 */
export function instanceOfFieldNamesMeta(value: object): value is FieldNamesMeta {
    if (!('numeric' in value) || value['numeric'] === undefined) return false;
    if ((!('extraData' in (value as Record<string, any>)) && !('extra_data' in (value as Record<string, any>))) || ((value as Record<string, any>)['extraData'] === undefined && (value as Record<string, any>)['extra_data'] === undefined)) return false;
    if ((!('siteExtraData' in (value as Record<string, any>)) && !('site_extra_data' in (value as Record<string, any>))) || ((value as Record<string, any>)['siteExtraData'] === undefined && (value as Record<string, any>)['site_extra_data'] === undefined)) return false;
    return true;
}

export function FieldNamesMetaFromJSON(json: any): FieldNamesMeta {
    return FieldNamesMetaFromJSONTyped(json, false);
}

export function FieldNamesMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldNamesMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'numeric': json['numeric'],
        'extraData': json['extra_data'],
        'siteExtraData': json['site_extra_data'],
    };
}

export function FieldNamesMetaToJSON(json: any): FieldNamesMeta {
    return FieldNamesMetaToJSONTyped(json, false);
}

export function FieldNamesMetaToJSONTyped(value?: FieldNamesMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'numeric': value['numeric'],
        'extra_data': value['extraData'],
        'site_extra_data': value['siteExtraData'],
    };
}

